module.exports = __webpack_public_path__ + "static/monthly_plan-1e3b9c746aa1bbfc848cc35d32741d68.jpg";